// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__CqDxT","title":"Modal_title__23QgT","description":"Modal_description__CF7rx"};